import * as React from 'react';
import { Button, Flex, Heading, HStack, Image } from '@chakra-ui/react';
import { useNavigate } from 'react-router';
import { PageContainer } from '../../components/container';
import { useAuth } from '../../../context/AuthContext.component';

export default function NotFoundPage() {
    let navigate = useNavigate();
    let auth = useAuth();

    return (
        <PageContainer pageTitle="404 Not Found">
            <Flex w='full' align='center' direction='column' m={8} gap={6}>
                <Heading size='4xl' textColor='var(--Able-blue)'>404</Heading>
                <Heading size='xl' textAlign='center'>Oops! We can't seem to find that page.</Heading>
                <Button colorScheme='blue' variant='link' size='lg' onClick={() => navigate("/customer/overview/" + auth.user?.job_number)}>Go back to your Job</Button>

                <HStack flexGrow={1} align='end'>
                    <Heading size='md' fontWeight='semibold'>Still a bit lost?</Heading>
                    <Button as='span' colorScheme='blue' variant='link' size='lg' onClick={() => window.location.replace("https://www.able-group.co.uk")}>Go to our website</Button>
                </HStack>
            </Flex>
        </PageContainer>
    );
}